define('models/calendar/item/personal-data',[
    'underscore', 'backbone', 'mustache', 'utils',
    // Services
    'services/i18n',
    'services/user',
    'services/unit-converter',
    // Parents
    'models/calendar/item'
], function(
    _, Backbone, Mustache, U,
    // Services
    i18n,
    User,
    UnitConverter,
    // Parents
    MCalendarItem
) {

    var MPersonalData = MCalendarItem.extend({
        defaults: function() {
            return {
                type: MPersonalData.type,
                customData: null,
                value: null,
                unit: null
            };
        },

        getUnit: function() {
            return this.get('unit');
        },

        getUserUnit: function() {
            switch (this.getUnit()) {
                case 'cm': return User.get('lengthUnit');
                case 'in': return User.get('lengthUnit');
                case 'km': return User.get('distanceUnit');
                case 'mi': return User.get('distanceUnit');
                case 'lbs': return User.get('weightUnit');
                case 'kg': return User.get('weightUnit');
                default: return this.getUnit();
            }
        },

        getValue: function() {
            if (this.get('value') && this.getUnit() !== this.getUserUnit()) {
                return UnitConverter.convert(this.get('value'), this.getUnit(), this.getUserUnit());
            }

            return this.get('value');
        },

        getDisplayTitle: function() {
            if (this.get('value') === '' || this.get('value') == null) {
                return Mustache.render('{{{name}}}', {
                    name: i18n.t(this.get('name'))
                });
            }

            return Mustache.render('{{{name}}} / {{value}} {{{unit}}}', {
                name: i18n.t(this.get('name')),
                value: this.getValue(),
                unit: i18n.t(this.getUserUnit())
            });
        }
    }, {
        ///////////////////
        // Class statics //
        ///////////////////
        type: 'custom_data',
    });

    return MPersonalData;
});

